
<h2 mat-dialog-title>{{'pass.widgets.chat' | translate}}</h2>
<mat-dialog-content>
  <section class="mt-1 mb-3 rounded m-auto w-100" id="section" >
    <form [formGroup]="formEditForm">

      <mat-form-field appearance="outline" class="w-100">
        <mat-label>{{'pass.name' | translate}}</mat-label>
        <input formControlName="name" type="text" matInput placeholder="{{'pass.name' | translate}}">
      </mat-form-field>

      <div class="d-flex flex-row">
        <div class="pe-2 flex-grow-1">
          <div class="input-group">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>{{'pass.title' | translate}}</mat-label>
              <input formControlName="title" type="text" matInput placeholder="{{'pass.title' | translate}}">
            </mat-form-field>
          </div>
        </div>
        <div class="ps-2 flex-grow-1">
          <div class="input-group">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>{{'pass.subtitle' | translate}}</mat-label>
              <input formControlName="subtitle" type="text" matInput placeholder="{{'pass.subtitle' | translate}}">
            </mat-form-field>
          </div>
        </div>
      </div>

      <div class="d-flex flex-row">
        <div class="pe-2 flex-grow-1">
          <div class="input-group">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>{{'pass.buttonImageURL' | translate}}</mat-label>
              <input formControlName="buttonImageURL" type="text" matInput placeholder="{{'enterURL' | translate}}">
            </mat-form-field>
          </div>
        </div>
      </div>

      <!-- <mat-form-field appearance="outline" class="w-100">
      <mat-label>{{'pass.prompt' | translate}}</mat-label>
      <input formControlName="prompt" type="text" matInput placeholder="{{'pass.prompt' | translate}}">
    </mat-form-field> -->

    <mat-accordion multi class="form-field-section">

      <!-- Payload Mapping ///////////// -->

      <mat-expansion-panel expanded>
        <mat-expansion-panel-header>
          <mat-panel-title style="color:#595c5f;">
            <mat-icon style="margin-right: 10px;">article</mat-icon>
            {{'pass.payloadMapping' | translate}}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="p-2">
          <button mat-button
            class="secondary-gray-button my-2"
            (click)="addPayloadContent();"
            >
            <mat-icon>add_circle</mat-icon> {{'add'  | translate}}
          </button>
          <div class="my-3" formArrayName="payloadMapping">
            @for (control of payloadArray.controls; track control; let i = $index) {
              <div>
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>{{ 'taskTemplates.payload_key' | translate }}</mat-label>
                  <input matInput type="text" [formControl]="control">
                  <button mat-icon-button matSuffix (click)="deletePayloadContent(i)">
                    <mat-icon class="material-symbols-outlined delete">delete</mat-icon>
                  </button>
                </mat-form-field>
              </div>
            }

          </div>
        </div>
      </mat-expansion-panel>


      <!-- Suggestions ///////////// -->

      <mat-expansion-panel expanded>
        <mat-expansion-panel-header>
          <mat-panel-title style="color:#595c5f;">
            <mat-icon style="margin-right: 10px;">reviews</mat-icon>
            {{'pass.suggestions' | translate}}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="p-2">
          <button mat-button
            class="secondary-gray-button my-2"
            (click)="addSuggestion();"
            >
            <mat-icon>add_circle</mat-icon> {{'add'  | translate}}
          </button>
          <div class="my-3" formArrayName="suggestions">
            @for (control of suggestionsArray.controls; track control; let i = $index) {
              <div>
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>{{ 'pass.suggestion' | translate }}</mat-label>
                  <input matInput type="text" [formControl]="control">
                  <button mat-icon-button matSuffix (click)="deleteSuggestion(i)">
                    <mat-icon class="material-symbols-outlined delete">delete</mat-icon>
                  </button>
                </mat-form-field>
              </div>
            }

          </div>
        </div>
      </mat-expansion-panel>

      <!-- Button Styles ///////////// -->

      <mat-expansion-panel expanded>
        <mat-expansion-panel-header>
          <mat-panel-title style="color:#595c5f;">
            <mat-icon style="margin-right: 10px;">palette</mat-icon>
            Button {{'pass.form.btn_form_style' | translate}}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="p-2 mt-2">
          <form [formGroup]="buttonStyleForm">

            <div class="d-flex flex-row">

              <mat-form-field appearance="outline" class="w-100">
                <mat-label>{{'pass.buttons.borderWidth' | translate}}</mat-label>
                <input formControlName="borderWidth" type="number" step="0.1" matInput min="0" placeholder="{{'pass.buttons.borderWidth' | translate}}">
                <span matSuffix class="p-3"> px</span>
              </mat-form-field>

            </div>

            <div class="list-group ">
              <div class="list-group-item">
                <div class="d-flex flex-row justify-content-between align-items-center flex-wrap">
                  <span class="w-50 bg-white" >{{'pass.buttons.backgroundColor' | translate}}</span>
                  <label class=" d-flex flex-row-reverse justify-content-start align-items-center" style="border-left:none;" >
                    <ngx-colors ngx-colors-trigger [palette]="colorPalette" [hideTextInput]="false" [format]="'hex'" cancelLabel="{{'pass.colorPickerCancel' | translate}}" acceptLabel="{{'pass.colorPickerConfirm' | translate}}" formControlName="background" style="margin-left:10px;"></ngx-colors>
                    @if (invalid_background) {
                      <span id="invalid_background" style="color:red;">{{'pass.invalid_color' | translate}}</span>
                    }
                  </label>
                </div>
              </div>

              <div class="list-group-item">
                <div class="d-flex flex-row justify-content-between align-items-center flex-wrap">
                  <span class="w-50 bg-white" >{{'pass.buttons.borderColor' | translate}}</span>

                  <label class=" d-flex flex-row-reverse justify-content-start align-items-center" style="border-left:none;" >
                    <ngx-colors ngx-colors-trigger [palette]="colorPalette" [hideTextInput]="false" [format]="'hex'" cancelLabel="{{'pass.colorPickerCancel' | translate}}" acceptLabel="{{'pass.colorPickerConfirm' | translate}}" formControlName="borderColor" style="margin-left:10px;"></ngx-colors>
                    @if (invalid_borderColor) {
                      <span id="invalid_borderColor" style="color:red;">{{'pass.invalid_color' | translate}}</span>
                    }
                  </label>
                </div>
              </div>

              <div class="list-group-item">
                <div class="d-flex flex-row justify-content-between align-items-center flex-wrap">
                  <span class="w-50 bg-white" >{{'pass.buttons.foregroundColor' | translate}}</span>

                  <div class=" d-flex flex-row-reverse justify-content-start align-items-center" style="border-left:none;" >
                    <ngx-colors ngx-colors-trigger [palette]="colorPalette" [hideTextInput]="false" [format]="'hex'" cancelLabel="{{'pass.colorPickerCancel' | translate}}" acceptLabel="{{'pass.colorPickerConfirm' | translate}}" formControlName="primary" style="margin-left:10px;"></ngx-colors>
                    @if (invalid_primary) {
                      <span id="invalid_primary" style="color:red;">{{'pass.invalid_color' | translate}}</span>
                    }
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </mat-expansion-panel>

    </mat-accordion>

  </form>

  <h4 class="py-4">{{'workTask.advanced_settings' | translate}}:</h4>
  <div class="mt-2" [app-widget-styling] = "{'form': formEditForm.value }" (returnChanges)="returnChangesStyle($event)"></div>
  <div class="mt-2" [app-widget-edit-filters] = "{'form': formEditForm.value }" (returnChanges)="returnChangesFilters($event)"></div>
</section>

</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button style="color:var(--warmOrange);" (click)="dialogCancel();" > {{'cancel' | translate}} </button>
  <button mat-button class="orange-button" (click)="dialogSave();"
  [disabled]="invalid_background || invalid_borderColor || invalid_primary || !formEditForm.valid">{{'apply' | translate}}</button>
</mat-dialog-actions>